import { ApolloError } from "@apollo/client";
import { Alert, Stack, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import GaiaHookFormSubmitButton from "~/modules/app/components/GaiaHookFormSubmitButton";
import useApplyErrorToForm from "~/modules/app/hooks/useApplyErrorToForm";

type FormData = {
    reason: string;
};

type Props = {
    onOverride: (reason: string) => Promise<void>;
    error?: ApolloError;
};

export default function OverrideAutoValidationForm({ onOverride, error }: Props) {
    const { t } = useTranslation("project");

    const {
        handleSubmit,
        register,
        setError,
        control,
        formState: { errors },
    } = useForm<FormData>({
        defaultValues: { reason: "" },
    });

    useApplyErrorToForm(error, setError);

    const handleOnSubmit = async ({ reason }: FormData) => {
        await onOverride(reason);
    };

    return (
        <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Stack rowGap={2}>
                {errors.root && (
                    <Alert severity="error">
                        <Typography>{errors.root.message}</Typography>
                    </Alert>
                )}
                <TextField
                    {...register("reason", { required: true })}
                    multiline
                    minRows={4}
                    required
                    label={t("projectReviewVisitV2.overrideAutoValidation.reasonForApproval")}
                    error={!!errors.reason}
                />
                <GaiaHookFormSubmitButton control={control}>
                    {t("projectReviewVisitV2.overrideAutoValidation.approveBtn")}
                </GaiaHookFormSubmitButton>
            </Stack>
        </form>
    );
}
